type UmamiEventData = Record<string, string | number | boolean | null | undefined>;

export function trackEvent(name: string, data?: UmamiEventData) {
    if (typeof window === "undefined" || typeof window.umami?.track !== "function") {
        return;
    }

    if (data) {
        window.umami.track(name, data);
        return;
    }

    window.umami.track(name);
}
